import React, { useEffect, useRef, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 数据源
import { ListStore } from '../../../store';
// 端外
import { Player } from '@ifeng-fe/three_terminal/es/mobile/video';
// setH5PageTouchArea禁止客户端默认手势区域 / setNoSlideArea组合设置客户端禁止手势区域  setPageNoActiveListener页面无活动监听
import { setH5PageTouchArea, setNoSlideArea, setPageNoActiveListener } from '@src/utils/app';
// 判断
import { isIOS } from '@src/utils';
const PlayerVideo = ({ content }) => {
    // 列表数据源
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { currentVideo } = listStates;

    // 视频引用（端外）
    const videoRef = useRef(); // 视频引用
    const videoApis = useRef(); // 视频控制功能
    const videoPosition = useRef(); // 视频位置
    const [videoHeight, serVideoHeight] = useState(0);

    // player视频播放器（端外）
    const option = {
        // 滑动组件配置
        config: {
            // 播放器宽
            // width: 325,
            // 播放器高
            height: videoHeight,
            // 是否自动播放
            autoPlay: false,
            // 是否显示播放控件
            controls: true,
            auth: true, // 防盗链，建议添加，如果guid未请求到数据会自动转为false
            showTitle: true, // 标题
            showPoster: true, // 封面
            showController: true, // 控制按钮
            m3u8Play: true,
            pauseAfterLeave: true, // 离开视口暂停
            singlePlay: true, // 单个播放
            isCircle: true,
            controlsList: 'nodownload',
            clickVideoStatisticsCB: () => {
                // console.log('首次点击播放器区域自定义统计上报，只触发一次');
            },
            firstFrameStatisticsCB: () => {
                // console.log('视频开始播放首帧自定义统计上报');
            },
            // 获取视频控制
            getExposeApisCb: apis => {
                videoApis.current = apis;
            },
            // 全屏触发
            fullscreenListener: isFull => {
                if (isIOS()) {
                    return;
                }
                if (isFull) {
                    videoPosition.current = document.documentElement.scrollTop || document.body.scrollTop;
                } else {
                    window.scroll(0, videoPosition.current);
                }
            },
        },

        videoinfo: {
            title: currentVideo.title,
            videoPlayUrl: currentVideo.videoPlayUrl,
            bigPosterUrl: currentVideo.posterUrl,
        },
    };

    // 设置端外
    useEffect(
        () => {
            if (videoRef.current) {
                const domRect = videoRef.current.getBoundingClientRect();
                const height = domRect.height;

                changeListStates({
                    statusBarHeight: 0,
                    videoHeight: String(Math.floor(height)),
                });
                serVideoHeight(height);
            }
        },
        [videoRef.current],
    );

    return (
        <>
            {currentVideo?.videoPlayUrl ? (
                <div
                    className={styles.top}
                    ref={videoRef}
                    onClick={() => {
                        const { top, bottom } = videoRef.current?.getBoundingClientRect();

                        setNoSlideArea([{ top, end: bottom, type: 'fixed' }]);
                        setH5PageTouchArea(top, bottom, window.innerHeight);
                    }}>
                    <div id="PlayerWrap">
                        <Player key={currentVideo.base62Id} videoConfig={option.videoinfo} playermsg={option.config} />
                    </div>
                </div>
            ) : null}
        </>
    );
};

PlayerVideo.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(PlayerVideo);
